import { ROLE_PERMISSIONS_BY_ADMIN_ROUTE } from './rolePermissionsByAdminRoute';
import { ROLE_PERMISSIONS_BY_MAIN_ROUTE } from './rolePermissionsByMainRoute';
import { ROLE_PERMISSIONS_BY_SYSTEM_ROUTE } from './rolePermissionsBySystemRoute';

import type { UserRole } from 'applications/GSP/shared/types';

export const ROLE_PERMISSIONS_BY_ROUTE: Readonly<Record<string, UserRole[]>> = {
  ...ROLE_PERMISSIONS_BY_ADMIN_ROUTE,
  ...ROLE_PERMISSIONS_BY_MAIN_ROUTE,
  ...ROLE_PERMISSIONS_BY_SYSTEM_ROUTE,
};
